export const BOX_STATUS_OPTIONS = [
  { id: 1, label: "Open", flow: "grey" },
  { id: 2, label: "Ready to ship", flow: "blue" },
  { id: 3, label: "Shipped", flow: "green" },
  { id: 4, label: "On Hold", flow: "main" },
  { id: 5, label: "Canceled", flow: "red" },
];

export const BOX_STATUS = {
  OPEN: 1,
  READY: 2,
  SHIPPED: 3,
  HOLD: 4,
  CANCELLED: 5,
};

export const BOX_TYPE_DICT = {
  PALETTE: 1,
  BOX: 2,
  BAG: 3,
};

export const BOX_GROUPS = [
  {
    id: BOX_TYPE_DICT.PALETTE,
    label: "Palette",
    flow: "blue",
  },
  {
    id: BOX_TYPE_DICT.BOX,
    label: "Box",
    flow: "main",
  },
  {
    id: BOX_TYPE_DICT.BAG,
    label: "Bag",
    flow: "green",
  },
];

export const BOXES = [
  { id: 1, w: 18, l: 18, h: 12, weight: 1.75, label: "Standard" },
  { id: 2, w: 14, l: 14, h: 14, weight: 1.25, label: "Half" },
  { id: 3, w: 14, l: 14, h: 9, weight: 1.1, label: "Half" },
  { id: 4, w: 10, l: 10, h: 10, weight: 0.65, label: "Half" },
  { id: 5, w: 12, l: 9, h: 9, weight: 0.85, label: "Quarter" },
  { id: 6, w: 9, l: 9, h: 6, weight: 0.65, label: "Eighth" },
  { id: 7, w: 6, l: 6, h: 6, weight: 0.65, label: "Small" },
  { id: 8, w: 8, l: 10, h: 8, weight: 0.65, label: "Small" },
]?.map((b) => ({
  ...b,
  label: `${b.w}" x ${b.l}"${b?.h ? ` x ${b.h}"` : ""}${b?.label ? ` ${b.label}` : ""
    }`,
  type: BOX_GROUPS[1].label,
}));

export const PALETTES = [
  { id: 9, w: 48, l: 40, label: "Standard", weight: 37 },
  { id: 10, w: 24, l: 40, label: "Half", weight: 20 },
  { id: 11, w: 24, l: 20, label: "Quarter", weight: 12 },
  { id: 12, w: 42, l: 42, weight: 34 },
  { id: 13, w: 48, l: 48, weight: 40 },
  { id: 14, w: 36, l: 36, weight: 30 },
  { id: 15, w: 48, l: 45, weight: 38 },
  { id: 16, w: 48, l: 20, weight: 22 },
]?.map((b) => ({
  ...b,
  label: `${b.w}" x ${b.l}"${b?.h ? ` x ${b.h}"` : ""}${b?.label ? ` ${b.label}` : ""
    }`,
  type: BOX_GROUPS[0].label,
}));

export const BAGS = [
  { id: 17, w: 2, l: 3, weight: 0.1 },
  { id: 18, w: 3, l: 5, weight: 0.15 },
  { id: 19, w: 4, l: 6, weight: 0.2 },
  { id: 20, w: 5, l: 7, weight: 0.25 },
  { id: 21, w: 6, l: 9, weight: 0.3 },
  { id: 22, w: 8, l: 10, weight: 0.4 },
  { id: 23, w: 9, l: 12, weight: 0.45 },
  { id: 24, w: 10, l: 13, weight: 0.5 },
  { id: 25, w: 12, l: 15, weight: 0.6 },
  { id: 26, w: 13, l: 18, weight: 0.7 },
]?.map((b) => ({
  ...b,
  label: `${b.w}" x ${b.l}"${b?.h ? ` x ${b.h}"` : ""}${b?.label ? ` ${b.label}` : ""
    }`,
  type: BOX_GROUPS[2].label,
}));

export const BOX_TYPES = [PALETTES, BOXES, BAGS].flat();
